export function fmtDateTime(iso?: string | null): string {
  if (!iso) {
    return '—'
  }
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) {
    return iso
  }
  return d.toLocaleString()
}

export function formatDuration(ms?: number): string {
  if (!ms) {
    return '—'
  }
  if (ms < 1000) {
    return `${ms}ms`
  }
  if (ms < 60000) {
    return `${(ms / 1000).toFixed(1)}s`
  }
  return `${(ms / 60000).toFixed(1)}m`
}

export function formatNumber(num?: number): string {
  if (!num) {
    return '0'
  }
  return num.toLocaleString()
}
